import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "firma";
var firmaService = {


    dbKontrol(dbName) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                dbName: dbName,
                methodName: "dbKontrol"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },


    firmaTanimlama(firmaKodu, firmaAdi, siteAdi, vergiDairesi, vergiNo,yetkiliKodu,yetkili, slogan, siteAdresi, siteAdresi2, eposta, eposta2, telefon, sabitTelefon, dahili, fax, adres, koordinat, map, sosyalMedya) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: firmaKodu,
                firmaAdi: firmaAdi,
                siteAdi: siteAdi,
                vergiDairesi: vergiDairesi,
                vergiNo: vergiNo,
                yetkiliKodu: yetkiliKodu,
                yetkili: yetkili,
                slogan: slogan,
                siteAdresi: siteAdresi,
                siteAdresi2: siteAdresi2,
                eposta: eposta,
                eposta2: eposta2,
                telefon: telefon,
                sabitTelefon: sabitTelefon,
                dahili: dahili,
                fax: fax,
                adres: adres,
                koordinat: koordinat,
                map: map,
                sosyalMedya: sosyalMedya,
                methodName: "tanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    firmaGuncelle(updateList) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                updateList: updateList,
                methodName: "firmaGuncelleme"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    firmaDetay() {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                methodName: "firmaDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default firmaService